import { FaFacebook, FaXTwitter, FaInstagram, FaTiktok } from 'react-icons/fa6';

export default function SocialMediaButtons() {
    const iconClass = "cursor-pointer text-white bg-black rounded-full p-4 w-12 h-12 flex items-center justify-center text-xl hover:scale-110 transition-transform";
    return (
        <div className="flex container gap-4 items-center justify-between w-10">
            <a href="https://www.facebook.com/share/1HWt6eJtFm/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" className={iconClass}><FaFacebook /></a>
            <a href="https://x.com/inspiracambioac?s=21" target="_blank" rel="noopener noreferrer" className={iconClass}><FaXTwitter /></a>
            <a href="https://www.instagram.com/inspiracambioac?igsh=MzQzYTY3MmVkaXk4" target="_blank" rel="noopener noreferrer" className={iconClass}><FaInstagram /></a>
            <a href="https://www.tiktok.com/@inspiracambioac?_t=ZS-8x8YgscF4YT&_r=1" target="_blank" rel="noopener noreferrer" className={iconClass}><FaTiktok /></a>
        </div>
    );
}